<template>
  <CCard>
    <CCardHeader class="d-flex align-items-center">
      <TMessage content="New support" bold />
      <div class="ml-auto">
        <TButton
          color="primary"
          content="Create new"
          icon="cil-plus"
          @click="create"
          :options="{ disabled: loading }"
        />
      </div>
    </CCardHeader>
    <CCardBody>
      <SSelectSupportTypes
        :value.sync="type_id"
        label="Support type"
        class="mb-3"
        :prepend="[]"
      />
      <TInputText
        label="Title"
        placeholder="Title"
        :value.sync="title"
        class="mb-3"
      />
      <TInputTextarea
        label="Content"
        placeholder="Content"
        class="mb-3"
        :value.sync="description"
      />
      <TInputFile
        :value.sync="file"
        :multiple="false"
        accept="image/*,.pdf,.xlsx"
      />
    </CCardBody>
  </CCard>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      type_id: "",
      title: "",
      description: "",
      file: [],
    };
  },
  computed: {
    ...mapGetters({
      loading: "helper.supports.creating",
    }),
  },
  methods: {
    create() {
      let data = {
        type_id: this.type_id,
        title: this.title,
        description: this.description,
      };
      const dataClean = this.lodash.pickBy(data, this.lodash.identity);
      this.$store.dispatch("helper.supports.create", dataClean).then((data) => {
        if (this.file.length) {
          this.$store.dispatch("helper.support_contents.create", {
            support_id: data.id,
            attachment_file: this.file[0]?.file,
          });
        }
        this.$router.push({ path: `${data.id}` });
      });
    },
  },
};
</script>
